export const AUTH_TOKEN = 'x-api-token';
export interface ApiTokenHeader {
	'x-api-token': string;
}

export function apiTokenHeader(token: string): ApiTokenHeader {
	return {
		'x-api-token': token
	};
}

export interface IServerError extends Error {
	[key: string]: unknown;
}
